
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Lager 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 88.54 88.54"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h88.54v88.54H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M.31 49.4a44.25 44.25 0 0073.31 28l2.12-2A44.27 44.27 0 100 44.27c0 1.06.05 2.1.12 3.13z","fill":"#ee7203"}})]),_c('path',{attrs:{"d":"M28.28 40.46a52.84 52.84 0 00-5.4 8.87c1.47 1.14 8 4.62 20.14-4.87a16.35 16.35 0 01-2.87-1.1s1.18.08 4.71-2.2c3.11-2 5.91-5.42 8-8.1a27.22 27.22 0 01-2.78-1.15s2.07.05 5.49-2.7c3-2.45 6.5-6 6.51-5.87s-6.73-5.21-14.19-5.12a13.29 13.29 0 00-7.51 2.59 13 13 0 012.37-3.18c-4.42.15-8.6 1.34-11.94 4.56-4.49 4.32-4.4 7.74-4.41 7.72a24.36 24.36 0 01-.54-4.59c-5 6.87-7.45 15.77-4.44 22.2a40.69 40.69 0 0110.92-14.33l1.08-.86a41.81 41.81 0 0118.81-8.39 38.43 38.43 0 00-13.87 6.51l-1 .74a48.06 48.06 0 00-8 8z","fill":"#fff"}}),_c('ellipse',{attrs:{"cx":"62.07","cy":"53.67","rx":"3.02","ry":"8.34","transform":"rotate(-14.73 62.083 53.686)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"1.71"}}),_c('path',{attrs:{"fill":"#fff","d":"M60.29 46.39l-.71-1.56 27.36-12.4.43 1.69-27.08 12.27zM64.42 62.56l-.44-1.65 23.39-6.31-.42 1.47-22.53 6.49z"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-linejoin":"bevel","stroke-width":"8.67","stroke-dasharray":"6.51 2.17","d":"M56.86 55.12l-44.73 12.4"}})])
          )
        }
      }
    